<template>
  <el-form
    :model="rule"
    :rules="rules"
    ref="forms"
    class="demo-ruleForm"
    label-width="100px"
  >
    <el-form-item label="选择文件" prop="file">
      <input type="file" name="file" @change="getFile($event)" />
    </el-form-item>
    <el-form-item label="">
      <el-link target="_blank" :href="url" :underline="false">
        <el-button type="text">下载设备文件模版</el-button>
      </el-link>
    </el-form-item>
    <el-table
      :header-cell-class-name="cellClass"
      select-all="null"
      v-show="this.tableData.length"
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        :selectable="checkSelectable"
        label="111"
        type="selection"
        width="100"
      >
      </el-table-column>

      <el-table-column prop="id" label="设备编号" width="200">
      </el-table-column>

      <el-table-column prop="romModel" label="当前固件型号">
        <template slot-scope="scope">
          {{ scope.row.romModel }}
          <span
            v-show="!scope.row.romModel"
            style="color:red; margin-left:20px"
          >
            当前固件型号为空，禁止升级该设备
          </span>
          <span
            v-show="scope.row.romModel && romModel != scope.row.romModel"
            style="color:red; margin-left:20px"
          >
            *当前固件型号名称与要升级的固件型号名称不一致，存在升级风险，需要相关部门审核
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-show="!!pagin.total"
      @current-change="pageChange"
      background
      layout="prev, pager, next"
      :current-page="pagin.pageNum"
      :page-size="pagin.size"
      :total="pagin.total"
    >
    </el-pagination>
    <el-form-item
      v-show="!!pagin.total"
      style="display:flex;justify-content:center;align-items:center"
    >
      <el-button type="primary" @click="submit">提交</el-button>
      <el-button @click="block">返回</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import Pagination from "@/components/Pagination";

export default {
  data() {
    return {
      pagin: {
        pageNum: 1,
        size: 10,
        total: 0,
        // isDefaultPageSizes: true,
      },
      name: "edit",
      url: this.getEnv(),
      multipleSelection: [],
      allTableData: [],
      tableData: [],
      romModel: "",
      isRun: false,
      rule: {
        id: 0,
        file: [],
      },
      rules: {
        file: { required: true, message: "请上传文件" },
      },
    };
  },
  async created() {
    if (this.$route.params.id) {
      this.rule.id = this.$route.params.id;
      this.$http
        .get("/manage/firmLora/view/" + this.$route.params.id)
        .then((results) => {
          const { romModel: resRomModel } = results.data.data || {};
          this.romModel = resRomModel;
        });
    } else {
      this.$router.push("/firmware/lora/index");
    }
  },
  methods: {
    cellClass(row) {
      if (row.columnIndex === 0) {
        return "disabledCheck";
      }
    },
    checkSelectable(row, index) {
      return !!row.romModel;
    },
    handleSelectionChange(val) {
      if (this.isRun) {
        return;
      }
      console.log("---", val);

      if (val.length < this.multipleSelection.length) {
        this.multipleSelection = val;
        return;
      }
      let isFlag = true;
      this.tableData.forEach((item) => {
        if (item.romModel !== this.romModel) {
          isFlag = false;
        }
      });
      if (!isFlag) {
        if (confirm("前固件型号名称与要升级的固件型号名称不一致，存在升级风险，需要相关部门审核!")) {
          this.multipleSelection = val;
        }
        this.isRun = true;

        this.$refs.multipleTable.clearSelection();
        this.multipleSelection.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
        setTimeout(() => {
          this.isRun = false;
        }, 50);
        return;
      }

      this.multipleSelection = val;
    },
    pageChange(size) {
      this.isRun = true;

      console.log((size - 1) * this.pagin.size, size * this.pagin.size);
      this.tableData = this.allTableData.slice(
        (size - 1) * this.pagin.size,
        size * this.pagin.size
      );
      console.log(" this.multipleSelection", this.multipleSelection);

      setTimeout(() => {
        this.multipleSelection.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
        this.isRun = false;
      }, 300);
    },
    getEnv() {
      if (location.host == "localhost:8080") {
        return (
          document.location.protocol +
          "//" +
          "test.baitengfa.com/manage/dev/download/template"
        );
      } else if (location.host == "dev.iotmanage.baitengfa.com") {
        return (
          document.location.protocol +
          "//" +
          "dev.iotmanage.baitengfa.com/manage/dev/download/template"
        );
      } else if (location.host == "iotmanage.baitengfa.com") {
        return (
          document.location.protocol +
          "//" +
          "iotmanage.baitengfa.com/manage/dev/download/template"
        );
      }
    },
    submit() {
      //   this.$refs["forms"].validate((valid) => {
      //     if (valid) {
      //       let headers = {
      //         "Content-Type": "multipart/form-data",
      //       };
      //       let formData = new FormData();
      //       formData.append("id", this.rule.id);
      //       formData.append("file", this.rule.file);
      //       this.$http
      //         .post("/manage/firm/upgrade", formData, { headers: headers })
      //         .then((rs) => {
      //           if (rs.data.code == 0) {
      //             this.$message({
      //               message: "操作成功",
      //               type: "success",
      //             });
      //             this.$router.push("/firmware/lora/index");
      //           } else {
      //             this.$message({
      //               message: rs.data.message,
      //               type: "error",
      //             });
      //           }
      //         });
      //     }
      //   });
      this.$http
        .post(
          "/manage/firmLora/upgradeSave",
          { firmLoraId: this.rule.id, devIds: this.multipleSelection.map(item => item.id) },
          
        )
        .then((rs) => {
          if (rs.data.code == 0) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.$router.push("/firmware/lora/index");
          } else {
            this.$message({
              message: rs.data.message,
              type: "error",
            });
          }
        });
    },
    block() {
      this.$router.push("/firmware/lora/index");
    },
    getFile(event) {
      let headers = {
        "Content-Type": "multipart/form-data",
      };
      var file = event.target.files;
      for (var i = 0; i < file.length; i++) {
        //    上传类型判断
        var imgName = file[i].name;
        var idx = imgName.lastIndexOf(".");
        if (idx != -1) {
          var ext = imgName.substr(idx + 1).toUpperCase();
          ext = ext.toLowerCase();
          this.rule.file = file[i];
        }
      }
      if (this.rule.file) {
        let formData = new FormData();
        formData.append("file", this.rule.file);
        this.$http
          .post("/manage/firmLora/upgradeUploadFile", formData, {
            headers: headers,
          })
          .then((rs) => {
            const list = rs.data.data;
            this.allTableData = list;
            this.tableData = list.slice(0, this.pagin.size);
            this.pagin.total = list.length;
          });
      }
    },
  },
};
</script>
<style scoped lang="scss">
/* 去掉全选按钮 */
::v-deep .el-table .disabledCheck .cell .el-checkbox__inner {
  display: none !important;
}

::v-deep .el-table .disabledCheck .cell::before {
  content: "选中/反选";
  text-align: center;
  line-height: 37px;
}
</style>
